import { useSearchParams } from "react-router-dom";
import { VehiclesAdminContainer } from "./vehicles.admin.container";

export const VehiclesAdminRoute = () => {
   const [searchParams] = useSearchParams();
   const vFilters = searchParams.get("vFilters") ?? "-1";

   return <VehiclesAdminContainer key={vFilters} />;   
}